import React, { useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';

import { InfoMessage } from '@eika/attention-message';
import { LinkButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal } from '@eika/modal';
import { ButtonToggles } from '@eika/radio-button';

import { ButtonGroupChangeEvent, StringKeyValue } from '../../../actions/types';
import { ConsentData } from '../../../reducers/consent';

interface Props {
    onChange: ButtonGroupChangeEvent;
    data: ConsentData;
    text: StringKeyValue;
}

const Consent = ({ onChange, data, text }: Props): JSX.Element => {
    const id: string = useRef(uuid()).current;
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => setModalOpen(!modalOpen);
    const closeModal = () => setModalOpen(false);

    const { infoTekst, svarNeiTekst, popupTekst, tekster, samtykkeId, svar } = data;

    const consentOptions = [
        { value: 'JA', text: 'Ja' },
        { value: 'NEI', text: 'Nei' },
    ];

    return (
        <div className="consent" id={id}>
            <div className="loan-application-input">
                <ButtonToggles
                    label={infoTekst}
                    onChange={(e) => {
                        onChange({ name: samtykkeId.value, value: e });
                    }}
                    selectedOption={svar}
                    options={consentOptions}
                />
                {svar === 'NEI' && svarNeiTekst && (
                    <div style={{ marginTop: '20px' }}>
                        <InfoMessage text={svarNeiTekst} className="consent-item__info" />
                    </div>
                )}
            </div>
            {(tekster || popupTekst) && (
                <div style={{ marginBottom: '67px', marginTop: '20px' }}>
                    <LinkButton icon={IconTypes.INFO_36} onClick={toggleModal}>
                        {text.loanDetailsConsentTooltipText}
                    </LinkButton>
                </div>
            )}

            <Modal
                onClose={closeModal}
                open={modalOpen}
                setOpen={() => {}}
                id={`modal-${id}`}
                appNamespace="no-eika-kredittbank"
            >
                <div className="app-container-wrapper">
                    <h1>{data.tittel}</h1>
                    {tekster.filter(Boolean).map((text: string) => (
                        <p key={uuid()}>{text}</p>
                    ))}
                    {popupTekst && <p>{popupTekst}</p>}

                    <div className="text-center" style={{ marginTop: '37px' }}>
                        <StandardButton onClick={closeModal}>{text.loanDetailsConsentModalButtonText}</StandardButton>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Consent;
